export enum ECommerceProductExternalProvider {
  SHOPIFY = 'shopify',
  OPTICAL_CENTER = 'opticalCenter',
  HAVELLS = 'havells',
}
